var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"title"},[_vm._v("\n      立即接入KBmob，开启高价值变现之旅\n    ")]),_vm._v(" "),_c('div',{staticClass:"btn-box"},[_c('div',{staticClass:"btn",on:{"click":_vm.goToAdmin}},[_vm._v("立即注册")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02ce75de","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer-menu.vue
// module id = 223
// module chunks = 1